module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"TodoName":"Todo name"},"vi":{"TodoName":"Tên công việc"}}')
  delete Component.options._Ctor
}
